import React, { useEffect } from 'react';
import { Switch, Route, Redirect } from 'react-router';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga';

import Main from './containers/Main';
import SiteList from './containers/SiteList';
import SiteDetail from './containers/SiteDetail';
import Pickup from './containers/Pickup';
import Queue from './containers/Queue';
import QueueTableSize from './containers/QueueTableSize';
import QueueTicketType from './containers/QueueTicketType';
import QueueTimeSection from './containers/QueueTimeSection';
import QueueServiceType from './containers/QueueServiceType';
import QueueDate from './containers/QueueDate';
import QueueSpecialRequest from './containers/QueueSpecialRequest';
import QueuePersonalInfo from './containers/QueuePersonalInfo';
import QueuePreview from './containers/QueuePreview';
import Ticket from './containers/Ticket';
import QueueRequestTicketSuccess from './containers/QueueRequestTicketSuccess';
import Error from './containers/Error';

import { PATH } from './constants/paths';

const Routes = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.initialize(`${process.env.REACT_APP_GA_TRACKING_ID}`);
  }, [])

  useEffect(() => {
    ReactGA.pageview(location.pathname + location.search);
  }, [location])

  return (
    <Switch>
      <Route exact path={PATH.LANDING} component={Main} />

      {/* app urls */}
      <Route exact path={'/app/queue' + PATH.SITE_DETAIL + ':siteId/:language/:ticketId'} component={SiteDetail} />
      <Route exact path={'/app/queue' + PATH.TICKET + ':language/:ticketId'} component={Ticket} />
      <Route exact path={'/app/queue' + PATH.TICKET + ':ticketId'} component={Ticket} />
      <Route exact path={'/app/site/:language/:siteId'} component={SiteDetail} />
      {/* app urls end */}

      <Route exact path={PATH.SITE_LIST + ':folderCode/:language'} component={SiteList} />
      <Route exact path={PATH.SITE_LIST + ':folderCode'} component={SiteList} />
      <Route exact path={PATH.SITE_DETAIL + ':siteId/:language/:ticketId'} component={SiteDetail} />
      <Route exact path={PATH.SITE_DETAIL + ':siteId/:language'} component={SiteDetail} />
      <Route exact path={PATH.SITE_DETAIL + ':siteId'} component={SiteDetail} />
      <Route exact path={PATH.PICKUP + ':restUrlId'} component={Pickup} />

      <Route exact path={PATH.QUEUE_CURRENT_SECTION + ':siteId'} component={Queue} />
      <Route exact path={PATH.QUEUE_SIZE + ':siteId'} component={QueueTableSize} />
      <Route exact path={PATH.QUEUE_TICKET_TYPE + ':siteId'} component={QueueTicketType} />
      <Route exact path={PATH.QUEUE_TIME_SECTION + ':siteId'} component={QueueTimeSection} />
      <Route exact path={PATH.QUEUE_SERVICE_TYPE + ':siteId'} component={QueueServiceType} />
      <Route exact path={PATH.QUEUE_DATE + ':siteId'} component={QueueDate} />
      <Route exact path={PATH.QUEUE_TAGS + ':siteId'} component={QueueSpecialRequest} />
      <Route exact path={PATH.QUEUE_PERSONAL_INFO + ':siteId'} component={QueuePersonalInfo} />
      <Route exact path={PATH.QUEUE_PREVIEW + ':siteId'} component={QueuePreview} />
      <Route exact path={PATH.TICKET + ':language/:ticketId'} component={Ticket} />
      <Route exact path={PATH.TICKET + ':ticketId'} component={Ticket} />
      <Route exact path={PATH.QUEUE_REQUEST_TICKET_SUCCESS + ':siteId'} component={QueueRequestTicketSuccess} />
      <Route exact path={PATH.QUEUE_REQUEST_TICKET_SUCCESS} component={QueueRequestTicketSuccess} />

      <Route exact path={PATH.ERROR} component={Error} />
      <Route exact path={'*'}> <Redirect to={PATH.ERROR} /></Route>
    </Switch>
  )
}

export default Routes;
